import React from 'react';
import {
  Typography,
  Box,
} from '@mui/material';
import ArtworksComponent from '../Components/ArtworksComponent';
import BackHeader from '../Components/BackHeader';
import { useLocation } from "react-router-dom";

const Artworks = () => {
const location = useLocation();
  const { artist,userProfileName,isStore,isStudio } = location.state || {};
  const store = artist?.store;
  const studio = artist?.studio;

  return (
    <Box>
      <BackHeader />
      {isStore && store?.length > 0 && (
        <>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                fontFamily: "basic-sans",
                fontWeight: "normal",
                marginRight: 2,
              }}
            >
              {userProfileName + "'s Store"}
            </Typography>
          </Box>
          <ArtworksComponent artworks={store} />
        </>
      )}

      {isStudio && studio?.length > 0 && (
        <>
          <Box sx={{ display: "flex", alignItems: "center", mt: 5 }}>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                fontFamily: "basic-sans",
                fontWeight: "normal",
                marginRight: 2,
              }}
            >
              {userProfileName + "'s Studio"}
            </Typography>
          </Box>
          <ArtworksComponent artworks={studio} />
        </>
      )}
    </Box>
  );
};

export default Artworks;
